var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',[_c('p',{staticClass:"title"},[_vm._v("Performances report for SNAP GPT tests")]),_c('p',{staticClass:"subtitle"},[_vm._v("A simple util to track SNAP project development")])])
}]

export { render, staticRenderFns }